import { cn } from "@/lib/utils";
import Popup from "@/components/ui/popup";
import {
  PUZZLE_DIFFICULTY_OPTIONS,
  PuzzleDifficultyKey,
} from "./puzzleDifficulty";
import type { Translate } from "next-translate";

export default function PuzzleDifficultyPopup({
  selectedDifficulty,
  lockedToBalanced = false,
  onSelect,
  onClose,
  t,
}: {
  selectedDifficulty: PuzzleDifficultyKey;
  lockedToBalanced?: boolean;
  onSelect: (difficulty: PuzzleDifficultyKey) => void;
  onClose: () => void;
  t: Translate;
}) {
  return (
    <Popup title={t("league.settings")} onClose={onClose} maxWidth="420px">
      <h2 className="mb-3 text-sm font-semibold text-slate-700">
        {t("league.difficultyHeading")}
      </h2>
      {lockedToBalanced && (
        <p className="mb-3 text-sm text-slate-600">
          {t("league.placementDifficulty")}
        </p>
      )}
      <div className="grid gap-2">
        {PUZZLE_DIFFICULTY_OPTIONS.map((option) => {
          const selected = option.key === selectedDifficulty;
          const disabled = lockedToBalanced && option.key !== "balanced";

          return (
            <button
              key={option.key}
              type="button"
              className={cn(
                "flex w-full items-center justify-between rounded-md border px-3 py-3 text-left transition-colors",
                selected
                  ? "border-altblue-500 bg-altblue-50 text-altblue-800"
                  : "border-athens-gray-200 bg-white text-gray-700 hover:bg-athens-gray-100",
                disabled && "cursor-not-allowed opacity-45 hover:bg-white",
              )}
              disabled={disabled}
              onClick={() => {
                onSelect(option.key);
                onClose();
              }}
            >
              <span className="min-w-0">
                <span className="block text-sm font-bold">
                  {t(`league.difficulties.${option.key}.label`)}
                </span>
                <span className="block text-xs text-muted-foreground">
                  {t(`league.difficulties.${option.key}.description`)}
                </span>
              </span>
              {selected && (
                <span className="ml-3 rounded-full bg-altblue-500 px-2 py-0.5 text-xs font-bold text-white">
                  {t("league.selected")}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </Popup>
  );
}
